import { jsx as o } from "react/jsx-runtime";
import { RocheUIMainNavigationItem as m } from "../main-navigation-item/roche-main-navigation-item.js";
import n from "./roche-main-navigation.module.scss.js";
const p = ({ nav: i, primaryNavLabel: a, currentPage: r }) => /* @__PURE__ */ o("nav", { "aria-label": a, children: /* @__PURE__ */ o("ul", { className: n["main-navigation"], children: i == null ? void 0 : i.map((t, e) => (
  // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
  /* @__PURE__ */ o(m, { link: t, currentPage: r }, e)
)) }) });
export {
  p as RocheUIMainNavigation
};
